module.exports = __webpack_public_path__ + "static/media/shoulderFlexion.f4721787.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/fppExercises/shoulderFlexion.png
// module id = 2542
// module chunks = 0